<tlk-card [padding]="24">
	<div tlkCardContent>
		<div class="dentures__container">
			<div class="dentures__header">
				<h2 class="dentures__title">{{ 'FlexibleRxProcedure.DenturesCard' | translate }}</h2>
				<div class="dentures__arch-toggles">
					<tlk-slide-toggle
						class="dentures__arch-toggles-item"
						[formControl]="isUpperControl"
						[id]="'isUpper'"
						name="isUpperControl"
						labelPosition="left"
						[isDisabled]="(dentureUpperSectionIsReadonly$ | async) || (isReadOnly$ | async) || false"
						(disableChangeEvent)="switchOffControl($event, isUpperControl)"
					>
						{{ 'DentureDetails.UpperDentureTitle' | translate }}
					</tlk-slide-toggle>

					<tlk-slide-toggle
						class="dentures__arch-toggles-item"
						[formControl]="isLowerControl"
						[id]="'isLower'"
						name="isLowerControl"
						labelPosition="left"
						[isDisabled]="(dentureLowerSectionIsReadonly$ | async) || (isReadOnly$ | async) || false"
						(disableChangeEvent)="switchOffControl($event, isLowerControl)"
					>
						{{ 'DentureDetails.LowerDentureTitle' | translate }}
					</tlk-slide-toggle>
				</div>
			</div>

			<div class="dentures__form">
				<ng-container *ngIf="dentureFieldsVisibility$ | async as fieldsVisibility">
					<rx-procedure-type-control
						*ngIf="fieldsVisibility.procedureType"
						class="dentures__form-field"
						[id]="'type'"
					></rx-procedure-type-control>

					<rx-select
						class="dentures__form-field"
						*ngIf="fieldsVisibility.stage"
						[id]="'stage'"
						[label]="'DentureDetails.StageTitle' | translate"
						[formControl]="stageControl"
						[options]="stages$ | async"
						[isDisabled]="(isReadOnly$ | async) || false"
						[isCancellable]="true"
						(disableChangeEvent)="cleanControlWhenDisabled($event, stageControl)"
						name="stageControl"
					></rx-select>

				<rx-moulds-dropdown
					class="dentures__form-field"
					*ngIf="fieldsVisibility.mould"
					[id]="'mould'"
					[label]="'DentureDetails.MouldTitle' | translate"
					[formControl]="mouldControl"
					[options]="moulds$ | async"
					[isReadOnly]="(isReadOnly$ | async) || false"
					[isCancellable]="true"
					name="mouldControl"
				></rx-moulds-dropdown>

					<rx-select
						class="dentures__form-field"
						*ngIf="fieldsVisibility.shadeSystem"
						[id]="'shadeSystem'"
						[label]="'DentureDetails.ShadeSystemTitle' | translate"
						[formControl]="shadeSystemControl"
						[options]="shadeSystems"
						[isDisabled]="(isReadOnly$ | async) || false"
						[isCancellable]="false"
						[isRequired]="(shouldValidateForSend$ | async) || false"
						name="shadeSystemControl"
					></rx-select>

					<rx-select
						class="dentures__form-field"
						*ngIf="(teethShadesHasOptions$ | async) && fieldsVisibility.teethShade"
						[id]="'teethShade'"
						[label]="'DentureDetails.TeethShadeTitle' | translate"
						[formControl]="teethShadeControl"
						[options]="teethShades$ | async"
						name="teethShadeControl"
						[isDisabled]="!isTeethShadeEnabled"
						[isReadOnly]="(isReadOnly$ | async) || false"
						[isCancellable]="true"
						[isRequired]="(shouldValidateForSend$ | async) || false"
						[getOptionId]="teethShadeOptionId"
						[getOptionName]="teethShadeOptionName"
						[compareWith]="teethShadeCompareWith"
					></rx-select>

					<rx-text-input
						class="dentures__form-field"
						*ngIf="!(teethShadesHasOptions$ | async) && fieldsVisibility.teethShade"
						[id]="'teethShade'"
						[label]="'DentureDetails.TeethShadeTitle' | translate"
						[formControl]="teethShadeControl"
						[isDisabled]="!isTeethShadeEnabled || (isReadOnly$ | async) || false"
						[isRequired]="(shouldValidateForSend$ | async) || false"
						name="teethShadeControl"
					></rx-text-input>

					<rx-select
						class="dentures__form-field"
						*ngIf="fieldsVisibility.gingival"
						[id]="'gingivalShade'"
						[label]="'DentureDetails.GingivalShadeTitle' | translate"
						[formControl]="gingivalShadeControl"
						[options]="gingivalShades$ | async"
						[isDisabled]="(isReadOnly$ | async) || false"
						[isCancellable]="true"
						[isRequired]="(shouldValidateForSend$ | async) || false"
						name="gingivalShadeControl"
					></rx-select>
				</ng-container>
			</div>
		</div>
	</div>
</tlk-card>
